import View from 'mixins/view';
import MatchCalendarView from 'ui/matchCalendar/match-calendar-view';
import moment from 'moment/moment';

export const elements = {
    container: '.match-heading',
};

export default class extends View {
    constructor(model) {
        super(model);
        this.setRootEl($(elements.container));
    }
    render() {
        this.calendar = new MatchCalendarView(this.model);
        this.calendar.render();
    }
}



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/ui/matchCalendar/match-heading-view.js